import { useState } from "react";
import { BrowserProvider, ethers, formatEther } from "ethers";
import { useToast } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { selectForm, setRecipientAddress, setSelectedCoinAmount, setTxHash, setWalletAmount, sidebarTabClick } from "store/slices";

export const useCryptoTransfer = (initialRecipientAddress = "") => {
  const recipientAddress = initialRecipientAddress;
  const [transactionHash, setTransactionHash] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const toast = useToast();
  const dispatch = useDispatch();
  const { selectedCoinAmount, walletAmount } = useSelector(selectForm);
  const amount = selectedCoinAmount;

  const handleTransfer = async () => {
    try {
      setIsLoading(true);

      const provider = new BrowserProvider(window.ethereum);
      const signer = provider.getSigner();

      const tx = (await signer).sendTransaction({
        to: recipientAddress,
        value: ethers.parseEther(String(amount)),
      });

      const result = await tx;

      setTransactionHash(result.hash);

      if (result.hash) {
        toast({
          position: "bottom-right",
          title: "Success",
          description: "Transfer successful",
          status: "success",
          duration: 9000,
          isClosable: true,
        });

        dispatch(setTxHash(result.hash));
      }

      console.log(result, "RESULT");
      const totalAmount = result.gasLimit + result.gasPrice + result.value + result.gasLimit;

      const formattedBalance = (totalAmount && formatEther(totalAmount!)) as string;

      const updateValue = Number(walletAmount) - Number(formattedBalance);

      dispatch(setWalletAmount(Number(updateValue).toFixed(6)));

      setIsLoading(false);

      dispatch(setSelectedCoinAmount(null));

      dispatch(setRecipientAddress(null));
    } catch (error) {
      dispatch(sidebarTabClick("quotes"));
      dispatch(setRecipientAddress(null));

      const err = JSON.parse(JSON.stringify(error));

      console.log(err, "THE ERR");

      setIsLoading(false);

      const message = String(err.info.error.message).split(":")[2];

      toast({
        position: "bottom-right",
        title: "Error",
        description: `${message}`,
        status: "error",
        duration: 10000,
        isClosable: true,
      });
    }
  };

  return {
    amount,
    recipientAddress,
    transactionHash,
    // error,
    isLoading,
    handleTransfer,
  };
};

// const d = {
//   totalCharge: 3541000025000027300n,
//   updateValue: 2.234799974999973,
// };

// 2.234275
